export const SET_REPORT = "SET_REPORT";
export default {
  SET_REPORT,
};
